import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

import ViewBookingType from "./ViewBookingType";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";

import { bookingApi } from "functions/apis";
import { token } from "functions/Helper";

const useStyles = makeStyles(styles);

export default function DeactivateBookingType(props) {
  const source = useRef(new AbortController());

  useEffect(() => {
    return () => source.current.abort();
  }, []);
  const { id } = useParams();
  const [bookingType, setBookingType] = React.useState(null);
  const [redirect, setRedirect] = React.useState(false);
  useEffect(() => {
    bookingApi
      .get("/BookingTypes/" + id, {
        signal: source.current.signal
      })
      .then(data => setBookingType(data))
      .catch(error => console.log(error));
  }, [id]);

  const [disabled, setDisabled] = React.useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    bookingApi
      .post(
        "/BookingTypes/Deactivate",
        {
          id: id
        },
        {
          signal: source.current.signal
        }
      )
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();
  return redirect ? (
    <Redirect to="/admin/BookingTypes/Published" />
  ) : (
    bookingType !== null && (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>DEACTIVATE BOOKING TYPE</h4>
            </CardHeader>
            <CardBody>
              <p>Deactivate this BookingType?</p>
              <form onSubmit={handleSubmit}>
                <Button onClick={() => props.history.goBack()} value="Cancel">
                  Cancel
                </Button>
                {(token["booking.booking_types.deactivate"] === "allowed" ||
                  token.is_admin === "True") && (
                  <Button
                    disabled={disabled}
                    color="rose"
                    type="submit"
                    value="Submit"
                  >
                    DEACTIVATE
                  </Button>
                )}
              </form>
              <ViewBookingType bookingType={bookingType} />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  );
}

DeactivateBookingType.propTypes = {
  history: PropTypes.object
};
